import React from 'react';
import './MultiSelectBox.css';
import {Checkbox, CheckboxGroup} from 'react-checkbox-group';
export default (props) => {
	//if statement to catch no items
    
	return (
		< div >
			<p className="filterTypeHeader">{props.boxLabel}</p>
			<div className={'optionBox ' + props.boxClassName}>
				{
					props.items ?
						<CheckboxGroup name={props.boxLabel} value={props.checked} onChange={props.onChange}>
							{props.items.map((item, i) => {
								return (
									<div key={i} className="optionGroup">
										<label>
											<Checkbox value={item.id} />
											{item.name}
										</label>
									</div>
								);
							})}
						</CheckboxGroup>
						:
						<div>No Options</div>
				}
			</div>
		</div >
	);
};



// WEBPACK FOOTER //
// ./src/Components/Filters/MultiSelectBox/MultiSelectBox.js